import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardHeader,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  CircularProgress,
  Typography,
  Box,
  Tabs,
  Tab,
  Chip,
  Tooltip,
  TablePagination,
  TextField, Alert, Snackbar, Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import {
  Person,
  Email,
  Work,
  SupervisorAccount,
  Looks3,
  EventAvailable,
  Notifications,
  CheckCircle,
  Mail,
  Search,
  Cancel,
  Warning,
  AccessTime,
  Schedule as ScheduleIcon,
  Mic,
  Stop,
  RecordVoiceOver,
  HowToReg
} from '@mui/icons-material';
import InterviewBot from './InterviewChatBot.jsx';
import InterviewModeSelector from './InterviewModeSelector.jsx';
import InterviewStatusUpdate from './interviewstatus.jsx';
import OfferManagementCandidate from './CandidateAcceptOffer.jsx';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const WS_URL = process.env.REACT_APP_WS_URL || 'ws://localhost:5000';

const StatusPage = () => {
  const [interviews, setInterviews] = useState([]);
  const [selectedInterview, setSelectedInterview] = useState(null); // For status update
  const [interviewForMode, setInterviewForMode] = useState(null); // For mode selection
  const [transcriptInterview, setTranscriptInterview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredInterviews, setFilteredInterviews] = useState([]);
  const [isRecording, setIsRecording] = useState(false);
  const [currentRecordingInterview, setCurrentRecordingInterview] = useState(null);
  const [socket, setSocket] = useState(null);
  const [transcript, setTranscript] = useState('');
  const [showTranscript, setShowTranscript] = useState(false);
  const [liveTranscript, setLiveTranscript] = useState('');
  const [recognition, setRecognition] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [activeInterview, setActiveInterview] = useState(null);
  const [interviewMode, setInterviewMode] = useState(null);
  const [showModeSelector, setShowModeSelector] = useState(false);
// Add this to your component's state declarations
const [isSpeaking, setIsSpeaking] = useState(false);
  const [alert, setAlert] = useState({
    open: false,
    message: '',
    severity: 'info'
  });
  const navigate = useNavigate();

  const fetchInterviews = async () => {
    try {
      const token = localStorage.getItem('token'); 
      if (!token) {
        alert("No authentication token found. Please log in.");
        return;
      }
      const payload = JSON.parse(atob(token.split('.')[1]));
      const company_id = payload.company_id;
      const response = await fetch(`${API_URL}/api/interviews`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
         
          }
        }
      );
      const data = await response.json();
      
      const processedData = Array.isArray(data) ? data : 
                          data?.interviews ? data.interviews : [];
      
      setInterviews(processedData);
      setFilteredInterviews(processedData);
    } catch (error) {
      //console.error('Error fetching interviews:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredInterviews(interviews);
    } else {
      const lowercasedQuery = searchQuery.toLowerCase();
      const filtered = interviews.filter((interview) => {
        return (
          interview.name.toLowerCase().includes(lowercasedQuery) ||
          interview.candidateEmail.toLowerCase().includes(lowercasedQuery) ||
          interview.positionApplied.toLowerCase().includes(lowercasedQuery) ||
          interview.hiringManagerEmail.toLowerCase().includes(lowercasedQuery) ||
          interview.status.toLowerCase().includes(lowercasedQuery) ||
          (interview.result && interview.result.toLowerCase().includes(lowercasedQuery))
        );
      });
      setFilteredInterviews(filtered);
    }
  }, [searchQuery, interviews]);

  useEffect(() => {
    fetchInterviews();
  }, []);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // const startRecording = async (interview) => {
  //   try {
  //     if (!('webkitSpeechRecognition' in window || 'SpeechRecognition' in window)) {
  //       alert('Your browser does not support speech recognition. Please use Chrome, Edge, or Safari.');
  //       return;
  //     }

  //     const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  //     const recognition = new SpeechRecognition();
      
  //     recognition.continuous = true;
  //     recognition.interimResults = true;
  //     recognition.lang = 'en-US';

  //     const ws = new WebSocket(`${WS_URL}/interview-stream`);
  //     setSocket(ws);

  //     ws.onopen = () => {
  //       ws.send(JSON.stringify({ 
  //         type: "start", 
  //         interviewId: interview.interviewId,
  //         mode: "manual"
  //       }));
  //       setIsRecording(true);
  //       setCurrentRecordingInterview(interview);
  //       setTranscript('');
  //       setLiveTranscript('');
        
  //       recognition.start();
  //     };

  //     ws.onmessage = (event) => {
  //       try {
  //         const data = JSON.parse(event.data);
  //         if (data.type === 'transcript_update') {
  //           setLiveTranscript(data.fullTranscript || '');
  //         } else if (data.type === 'completed') {
  //         }
  //       } catch (error) {
  //       }
  //     };

  //     ws.onerror = (error) => {
  //       //console.error('WebSocket error:', error);
  //     };

  //     recognition.onresult = (event) => {
  //       let finalTranscript = '';
  //       let interimTranscript = '';

  //       for (let i = event.resultIndex; i < event.results.length; i++) {
  //         const transcript = event.results[i][0].transcript;
  //         if (event.results[i].isFinal) {
  //           finalTranscript += transcript + ' ';
  //         } else {
  //           interimTranscript += transcript;
  //         }
  //       }

  //       if (finalTranscript.trim() !== '' && ws.readyState === WebSocket.OPEN) {
  //         ws.send(JSON.stringify({
  //           type: 'transcript_chunk',
  //           text: finalTranscript
  //         }));
  //       }

  //       if (interimTranscript !== '') {
  //         setLiveTranscript(prev => prev + ' ' + interimTranscript);
  //       }
  //     };

  //     recognition.onerror = (event) => {
  //       //console.error('Speech recognition error:', event.error);
  //       if (event.error === 'not-allowed') {
  //         alert('Microphone permission denied. Please allow microphone access.');
  //         stopRecording();
  //       }
  //     };

  //     recognition.onend = () => {
  //       if (isRecording) {
  //         recognition.start();
  //       }
  //     };

  //     setRecognition(recognition);

  //   } catch (error) {
  //     //console.error('Error starting recording:', error);
  //     alert('Error starting recording: ' + error.message);
  //   }
  // };

  const startRecording = async (interview) => {
    try {
      if (!('webkitSpeechRecognition' in window || 'SpeechRecognition' in window)) {
        alert('Your browser does not support speech recognition. Please use Chrome, Edge, or Safari.');
        return;
      }

      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      const recognition = new SpeechRecognition();
      
      // ENHANCED CONFIGURATION
      recognition.continuous = true;
      recognition.interimResults = true;
      recognition.lang = 'en-US';
      recognition.maxAlternatives = 3; // Get multiple alternatives for better accuracy
      recognition.interimResults = true;
      
      // Optional: Add grammars for technical terms (if you have them)
      // const grammar = '#JSGF V1.0; grammar tech; public <tech> = react | javascript | node | python | java | html | css | database | virtual dom | mongodb | sql;';
      // const speechRecognitionList = new webkitSpeechGrammarList();
      // speechRecognitionList.addFromString(grammar, 1);
      // recognition.grammars = speechRecognitionList;

      const ws = new WebSocket(`${WS_URL}/interview-stream`);
      setSocket(ws);

      ws.onopen = () => {
        ws.send(JSON.stringify({ 
          type: "start", 
          interviewId: interview.interviewId,
          mode: "manual"
        }));
        setIsRecording(true);
        setCurrentRecordingInterview(interview);
        setTranscript('');
        setLiveTranscript('');
        
        recognition.start();
      };

      ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          if (data.type === 'transcript_update') {
            setLiveTranscript(data.fullTranscript || '');
          } else if (data.type === 'completed') {
          }
        } catch (error) {
        }
      };

      ws.onerror = (error) => {
        //console.error('WebSocket error:', error);
      };

      // TECHNICAL TERMS DICTIONARY FOR CORRECTION
      const technicalDictionary = {
        'virtual dog': 'Virtual DOM',
        'nois qureshi': 'NoSQL',
        'no sequel': 'NoSQL',
        'my sequel': 'MySQL',
        'postgres': 'PostgreSQL',
        'mongo': 'MongoDB',
        'react': 'React',
        'javascript': 'JavaScript',
        'node': 'Node.js',
        'html': 'HTML',
        'css': 'CSS',
        'api': 'API',
        'json': 'JSON',
        'xml': 'XML',
        'sql': 'SQL',
        'angular': 'Angular',
        'vue': 'Vue',
        'typescript': 'TypeScript',
        'python': 'Python',
        'java': 'Java',
      };

      const correctTechnicalTerms = (text) => {
        let corrected = text;
        Object.entries(technicalDictionary).forEach(([wrong, correct]) => {
          const regex = new RegExp(`\\b${wrong}\\b`, 'gi');
          corrected = corrected.replace(regex, correct);
        });
        return corrected;
      };

      recognition.onresult = (event) => {
        let finalTranscript = '';
        let interimTranscript = '';

        for (let i = event.resultIndex; i < event.results.length; i++) {
          const result = event.results[i];
          const transcript = result[0].transcript;
          
          // Get the best alternative (highest confidence)
          let bestTranscript = transcript;
          if (result.length > 1) {
            // Choose alternative with highest confidence score
            let bestConfidence = result[0].confidence;
            for (let j = 1; j < result.length; j++) {
              if (result[j].confidence > bestConfidence) {
                bestTranscript = result[j].transcript;
                bestConfidence = result[j].confidence;
              }
            }
          }

          if (result.isFinal) {
            // Apply technical term correction to final results
            const correctedTranscript = correctTechnicalTerms(bestTranscript);
            finalTranscript += correctedTranscript + ' ';
          } else {
            interimTranscript += bestTranscript;
          }
        }

        if (finalTranscript.trim() !== '' && ws.readyState === WebSocket.OPEN) {
          ws.send(JSON.stringify({
            type: 'transcript_chunk',
            text: finalTranscript,
            timestamp: new Date().toISOString()
          }));
        }

        if (interimTranscript !== '') {
          const correctedInterim = correctTechnicalTerms(interimTranscript);
          setLiveTranscript(prev => {
            const base = prev.split(' ').slice(0, -3).join(' '); // Remove previous interim
            return (base + ' ' + correctedInterim).trim();
          });
        }
      };

      recognition.onerror = (event) => {
        //console.error('Speech recognition error:', event.error);
        if (event.error === 'not-allowed') {
          alert('Microphone permission denied. Please allow microphone access.');
          stopRecording();
        } else if (event.error === 'audio-capture') {
          alert('No microphone found. Please ensure a microphone is connected.');
          stopRecording();
        } else if (event.error === 'network') {
          alert('Network error occurred during speech recognition.');
        }
      };

      recognition.onend = () => {
        if (isRecording) {
          setTimeout(() => {
            try {
              recognition.start();
            } catch (error) {
              //console.error('Error restarting recognition:', error);
            }
          }, 100);
        }
      };

      // Add speech start/end events for better UX
      recognition.onspeechstart = () => {
        setIsSpeaking(true);
      };

      recognition.onspeechend = () => {
        setIsSpeaking(false);
      };

      setRecognition(recognition);

    } catch (error) {
      //console.error('Error starting recording:', error);
      alert('Error starting recording: ' + error.message);
    }
  };
  const stopRecording = () => {
    if (recognition) {
      recognition.stop();
      setRecognition(null);
    }

    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(JSON.stringify({ type: "stop" }));
      socket.close();
    }

    setIsRecording(false);
    setCurrentRecordingInterview(null);
    setSocket(null);
    
    setTimeout(() => {
      fetchInterviews();
    }, 1000);
  };

  // FIXED: Separate functions for different actions
  const startInterview = (interview) => {
    setInterviewForMode(interview); // Use separate state for mode selection
    setShowModeSelector(true);
  };

const handleModeSelected = async (sessionData) => {
  setShowModeSelector(false);

  try {
    const token = localStorage.getItem("token");
    const payload = JSON.parse(atob(token.split('.')[1]));
    const company_id = payload.company_id;
   if (sessionData.mode === 'manual') {
      startRecording(interviewForMode);
      return;
    }
    const response = await fetch(
      `${API_URL}/api/interviews/start-session`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(sessionData)   // <-- customQuestions SENT HERE
      }
    );

    const data = await response.json();

    if (data.success && sessionData.mode === 'ai') {
      // Start AI bot with uploaded or AI questions
      setActiveInterview({
        ...interviewForMode,
        questions: data.questions,
         preloadedQuestions: sessionData.preloadedQuestions,  // ← ADD THIS LINE
        questionSource: data.questionSource,
        // showInstruction:true,
      });
      setInterviewMode('ai');
    } else if (!data.success) {
      if (data.code === "AI_PLAN_UPGRADE_REQUIRED") {
        setAlert({
          open: true,
          message: data.message || "AI features are not included in your current plan. Please upgrade to unlock AI.",
          severity: "warning"
        });
        window.dispatchEvent(new CustomEvent("openUpgradeModal", { detail: { feature: "AI Interview" } }));
      } else if (data.code === "AI_TOKENS_EXHAUSTED") {
        setAlert({
          open: true,
          message: `⚠️ ${data.message || "You have used all your AI tokens for this billing cycle."}`,
          severity: "warning"
        });
      } else {
        setAlert({
          open: true,
          message: data.message || 'Failed to start interview',
          severity: 'error'
        });
      }
    }
  } catch (error) {
    setAlert({
      open: true,
      message: error.message || 'Failed to start interview',
      severity: 'error'
    });
  }
};

  // FIXED: Separate function for status update
  const handleUpdateStatus = (interview) => {
    setSelectedInterview(interview); // This is only for status update
  };

  const handleStatusUpdate = (updated) => {
    if (updated) fetchInterviews();
    setSelectedInterview(null);
  };

  const handleScheduleNextRound = (interview) => {
    const currentRoundNum = parseInt(interview.round.match(/Round (\d+)/)?.[1] || 0);
    const nextRound = currentRoundNum < 2 ? `Round ${currentRoundNum + 1}` : 'HR Round';

    navigate("/interview-scheduling", { 
      state: { 
        name: interview.name, 
        email: interview.candidateEmail,
        positionApplied: interview.positionApplied || "Not specified",
        skills: interview.skills || '', 
        experience: `${interview.experience} years`,
        round: nextRound,
        interviewer: ''
      } 
    });
  };

  const handleChangePage = (event, newPage) => setPage(newPage);
  
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getStatusChip = (status) => {
    const statusConfig = {
      scheduled: { color: '#bbdefb', textColor: '#0d47a1', label: 'Scheduled', icon: <EventAvailable fontSize="small" /> },
      completed: { 
        color: '#c8e6c9', 
        textColor: '#1b5e20', 
        label: 'Completed',
        icon: <CheckCircle fontSize="small" />
      },
      cancelled: { color: '#ffcdd2', textColor: '#b71c1c', label: 'Cancelled', icon: <Cancel fontSize="small" /> },
      pending: { color: '#fff9c4', textColor: '#f57f17', label: 'Pending', icon: <AccessTime fontSize="small" /> }
    };
 
    const config = statusConfig[status.toLowerCase()] || statusConfig.pending;
    
    return (
      <Chip
        label={config.label || status}
        icon={config.icon}
        size="small"
        sx={{
          backgroundColor: config.color,
          color: config.textColor,
          fontWeight: 'bold',
          minWidth: 90,
          '& .MuiSvgIcon-root': { color: config.textColor }
        }}
      />
    );
  };

  const getResultChip = (result) => {
    if (!result) return '-';
    
    const statusConfig = {
      selected: {
        color: '#c8e6c9',
        textColor: '#1b5e20',
        label: 'Selected',
        icon: <CheckCircle fontSize="small" />
      },
      rejected: {
        color: '#ffcdd2',
        textColor: '#b71c1c',
        label: 'Rejected',
        icon: <Cancel fontSize="small" />
      },
      'on hold': {
        color: '#ffe0b2',
        textColor: '#ef6c00',
        label: 'On Hold',
        icon: <Warning fontSize="small" />
      },
      pending: {
        color: '#fff9c4',
        textColor: '#f57f17',
        label: 'Pending',
        icon: <AccessTime fontSize="small" />
      }
    };
  
    const config = statusConfig[result.toLowerCase()] || {
      color: '#e0e0e0',
      textColor: '#424242',
      label: result,
      icon: null
    };
    
    return (
      <Chip
        label={config.label}
        icon={config.icon}
        size="small"
        sx={{
          backgroundColor: config.color,
          color: config.textColor,
          fontWeight: 'bold',
          minWidth: 90,
          '& .MuiSvgIcon-root': { color: config.textColor }
        }}
      />
    );
  };

  const viewTranscript = async (interview) => {
    try {
      setLoading(true);
      setTranscriptInterview(interview);
      
      if (!interview.transcript) {
        setTranscript('No transcript available');
        setShowTranscript(true);
        setLoading(false);
        return;
      }

      const response = await fetch(
        `${API_URL}/api/interviews/evaluate-transcript/${interview.interviewId}?company_id=${getCompanyId()}`, 
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization:`Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify({
            transcript: interview.transcript
          })
        }
      );

      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        if (errData?.code === "AI_PLAN_UPGRADE_REQUIRED") {
          setAlert({
            open: true,
            message: errData.message || "AI features are not included in your current plan. Please upgrade to unlock AI.",
            severity: "warning"
          });
          window.dispatchEvent(new CustomEvent("openUpgradeModal", { detail: { feature: "AI Evaluation" } }));
        } else if (errData?.code === "AI_TOKENS_EXHAUSTED") {
          setAlert({
            open: true,
            message: `⚠️ ${errData.message || "You have used all your AI tokens for this billing cycle."}`,
            severity: "warning"
          });
        } else {
          setAlert({
            open: true,
            message: errData?.message || 'Failed to evaluate transcript',
            severity: 'error'
          });
        }
        throw new Error(errData?.message || 'Failed to evaluate transcript');
      }

      const result = await response.json();
      
      setTranscriptInterview({
        ...interview,
        evaluation: result.evaluation,
        status: result.updatedInterview.status,
        result: result.updatedInterview.result,
        feedback: result.updatedInterview.feedback
      });

      setShowTranscript(true);
      
      setTimeout(() => {
        fetchInterviews();
      }, 1000);

    } catch (error) {
      //console.error('Error evaluating transcript:', error);
      setTranscript(interview.transcript || 'No transcript available');
      setShowTranscript(true);
    } finally {
      setLoading(false);
    }
  };

  const getCompanyId = () => {
    const token = localStorage.getItem('token');
    if (!token) return null;
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.company_id;
    } catch (error) {
      //console.error('Error parsing token:', error);
      return null;
    }
  };

  const isTechnicalRoundCompleted = (status, round, result) => {
    return status.toLowerCase() === 'completed' && 
           !round.toLowerCase().includes('hr') && 
           result !== 'Rejected';
  };
  const renderInterviewActions = (interview) => {
    const isManualRecording = isRecording && currentRecordingInterview?.interviewId === interview.interviewId;
    const isAIActive = activeInterview?.interviewId === interview.interviewId;
    const isOtherActive = (isRecording || activeInterview) && !isManualRecording && !isAIActive;

    return (
      <Box sx={{ display: 'flex', gap: 1, flexDirection: 'column', alignItems: 'flex-start' }}>
        {!isRecording && !activeInterview ? (
          <Button
            variant="contained"
            color="primary"
            size="small"
            startIcon={<RecordVoiceOver />}
            onClick={() => startInterview(interview)}
            sx={{ 
              borderRadius: 1,
              textTransform: 'none',
              minWidth: '140px'
            }}
          >
            Start Interview
          </Button>
        ) : null}

        {isManualRecording ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Button
              variant="contained"
              color="error"
              size="small"
              startIcon={<Stop />}
              onClick={stopRecording}
              sx={{ 
                borderRadius: 1,
                textTransform: 'none',
                minWidth: '140px'
              }}
            >
              Stop Recording
            </Button>
            <Chip 
              label="Manual Mode" 
              color="warning" 
              size="small" 
              variant="outlined"
            />
          </Box>
        ) : null}

        {isAIActive ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              disabled
              sx={{ 
                borderRadius: 1,
                textTransform: 'none',
                minWidth: '140px'
              }}
            >
              AI Interview Active
            </Button>
            <Chip 
              label="AI Mode" 
              color="primary" 
              size="small" 
              variant="outlined"
            />
          </Box>
        ) : null}

        {isOtherActive ? (
          <Button
            variant="outlined"
            size="small"
            disabled
            sx={{ 
              borderRadius: 1,
              textTransform: 'none',
              minWidth: '140px'
            }}
          >
            Another Interview Active
          </Button>
        ) : null}
        
        {interview.transcript && (
          <Button
            variant="outlined"
            size="small"
            onClick={() => viewTranscript(interview)}
            sx={{ 
              borderRadius: 1,
              textTransform: 'none',
              minWidth: '140px'
            }}
          >
            View Transcript
          </Button>
        )}
      </Box>
    );
  };

  return (
    <Box sx={{ padding: 1.5 }}>
      <Card sx={{ maxWidth: 1600, p: 3, borderRadius: 2, border: '2px solid', borderColor: 'grey.300', boxShadow: 4, mx: 'auto' }}>
        <CardHeader
          title={
            <Box sx={{ display: 'flex'}}>
              <Typography variant="h4" fontWeight="bold">
                {activeTab === 0 ? 'Interview Status' : 'Offer Management'}
                {isRecording && activeTab === 0 && (
                  <Chip 
                    icon={<Mic />}
                    label="Recording in Progress"
                    color="error"
                    sx={{ ml: 2, fontWeight: 'bold' }}
                  />
                )}
              </Typography>
            </Box>
          }
        />
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={activeTab} onChange={handleTabChange}  variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile >
            <Tab 
              icon={<EventAvailable />} 
              label="Interviews" 
              sx={{ fontWeight: 'bold' }}
            />
            <Tab 
              icon={<HowToReg />} 
              label="Offer Management" 
              sx={{ fontWeight: 'bold' }}
            />
          </Tabs>
        </Box>
        <CardContent>
          {activeTab === 0 ? (
            <>
              {isRecording && (
                <Alert severity="info" sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    Currently recording interview with {currentRecordingInterview?.name}
                  </Typography>
                  {liveTranscript && (
                    <Box sx={{ mt: 1, p: 1, backgroundColor: 'white', borderRadius: 1, border: '1px solid #e0e0e0' }}>
                      <Typography variant="body2" color="text.secondary">
                        <strong>Live Transcript:</strong> {liveTranscript}
                      </Typography>
                    </Box>
                  )}
                </Alert>
              )}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <TextField
                  label="Search"
                  variant="outlined"
                  size="small"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  InputProps={{
                    endAdornment: <Search color="action" />,
                  }}
                  sx={{ width: 300 }}
                />
              </Box>

              {/* FIXED: Use interviewForMode for mode selector */}
              {showModeSelector && interviewForMode && (
                <InterviewModeSelector
                  open={showModeSelector}
                  onClose={() => setShowModeSelector(false)}
                  interview={interviewForMode}
                  onModeSelected={handleModeSelected}
                />
              )}

              {/* {activeInterview && interviewMode === 'ai' && (
                <InterviewBot 
                  interview={activeInterview}
                  showInstructions={activeInterview.showInstructions}   // <-- NEW
                  onComplete={(finalTranscript) => {
                    setActiveInterview(null);
                    setInterviewMode(null);
                    fetchInterviews();
                    viewTranscript({ ...activeInterview, transcript: finalTranscript });
                  }}
                  onClose={() => {
                    setActiveInterview(null);
                    setInterviewMode(null);
                  }}
                />
              )} */}
              {activeInterview && interviewMode === 'ai' && (
  <InterviewBot 
    interview={activeInterview}
    onComplete={(finalTranscript) => {
      setActiveInterview(null);
      setInterviewMode(null);
      fetchInterviews();
      viewTranscript({ ...activeInterview, transcript: finalTranscript });
    }}
    onClose={() => {
      setActiveInterview(null);
      setInterviewMode(null);
    }}
  />
)}

              <TableContainer component={Paper} elevation={2}>
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                      <TableCell sx={{ fontWeight: 'bold' }}>Candidate</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Email</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Position</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Hiring Manager</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Round</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Schedule</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Result</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Offer</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Interview Actions</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', width: '150px' }}>Management</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredInterviews
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((interview) => (
                        <TableRow key={interview.interviewId} hover>
                          <TableCell>{interview.name}</TableCell>
                          <TableCell>
                            <Tooltip title={interview.candidateEmail}>
                              <span>{interview.candidateEmail}</span>
                            </Tooltip>
                          </TableCell>
                          <TableCell>{interview.positionApplied}</TableCell>
                          <TableCell>{interview.hiringManagerEmail}</TableCell>
                          <TableCell>{interview.round}</TableCell>
                          <TableCell>
  {interview?.interviewDate
    ? `${new Date(interview.interviewDate).toLocaleDateString()} ${interview?.interviewTime || ''}`
    : '-'}
</TableCell>
                          <TableCell>{getStatusChip(interview.status)}</TableCell>
                          <TableCell>{getResultChip(interview.result)}</TableCell>
                          <TableCell>
                            {interview.offerSent ? (
                              <Chip label="Yes" sx={{ backgroundColor: '#c8e6c9', color: '#1b5e20', fontWeight: 'bold' }} />
                            ) : (
                              <Chip label="No" sx={{ backgroundColor: '#ffcdd2', color: '#b71c1c', fontWeight: 'bold' }} />
                            )}
                          </TableCell>
                          <TableCell>
                            {renderInterviewActions(interview)}
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, width: '150px' }}>
                              {/* FIXED: Use handleUpdateStatus instead of setSelectedInterview directly */}
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                sx={{ 
                                  borderRadius: 1,
                                  textTransform: 'none',
                                  boxShadow: 'none',
                                  '&:hover': { boxShadow: 2 }
                                }}
                                onClick={() => handleUpdateStatus(interview)}
                              >
                                Update Status
                              </Button>
                              
                              {isTechnicalRoundCompleted(interview.status, interview.round, interview.result) && (
                                <Button
                                  variant="outlined"
                                  color="info"
                                  size="small"
                                  startIcon={<ScheduleIcon fontSize="small" />}
                                  sx={{ 
                                    borderRadius: 1,
                                    textTransform: 'none',
                                    mt: 0.5,
                                    '&:hover': { borderColor: '#2196f3', color: '#2196f3' }
                                  }}
                                  onClick={() => handleScheduleNextRound(interview)}
                                >
                                  Schedule Next Round
                                </Button>
                              )}
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={interviews.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableContainer>
            </>
          ) : (
            <OfferManagementCandidate />
          )}
        </CardContent>
      </Card>

      {/* Transcript Dialog */}
<Dialog open={showTranscript} onClose={() => setShowTranscript(false)} maxWidth="lg" fullWidth>
  <DialogTitle>
    Interview Transcript & AI Evaluation - {transcriptInterview?.name}
  </DialogTitle>
  <DialogContent>
    {loading ? (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress />
      </Box>
    ) : (
      <>
        <Typography variant="h6" gutterBottom>Transcript:</Typography>
        <Paper variant="outlined" sx={{ p: 2, mb: 3, backgroundColor: '#fafafa', minHeight: 200 }}>
          <Typography variant="body1" whiteSpace="pre-wrap">
            {transcriptInterview?.transcript}
          </Typography>
        </Paper>

        {transcriptInterview?.evaluation && (
          <>
            <Typography variant="h6" gutterBottom>AI Evaluation:</Typography>
            <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
              {transcriptInterview.evaluation.metrics?.map((metric, index) => (
                <Box key={index} sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    {metric.name}: {metric.score}/10
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {metric.justification}
                  </Typography>
                </Box>
              ))}
              <Box sx={{ mt: 3, p: 2, backgroundColor: '#e3f2fd', borderRadius: 1 }}>
                <Typography variant="h6">
                  Overall Score: {transcriptInterview.evaluation.overallScore}/10
                </Typography>
                <Typography variant="h6" color={
                  (transcriptInterview.evaluation.recommendation === 'Recommended' || transcriptInterview.evaluation.decision === 'Recommended' || transcriptInterview.evaluation.decision === 'Selected') 
                    ? 'success.main' : 'error.main'
                }>
                  AI Suggestion: {transcriptInterview.evaluation.recommendation || transcriptInterview.evaluation.decision}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1, fontStyle: 'italic' }}>
                  ℹ️ AI provides advisory recommendations only. The hiring decision (Selected / Rejected / On Hold) is taken by HR / Manager using "Update Status".
                </Typography>
                <Typography variant="body1" sx={{ mt: 1 }}>
                  {transcriptInterview.evaluation.feedbackSummary}
                </Typography>
              </Box>
            </Paper>
          </>
        )}
      </>
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setShowTranscript(false)}>Close</Button>
  </DialogActions>
</Dialog>

      {/* Status Update Dialog - Only shows when selectedInterview is set via handleUpdateStatus */}
      {selectedInterview && (
        <InterviewStatusUpdate
          interviewId={selectedInterview.interviewId}
          currentStatus={{
            status: selectedInterview.status,
            result: selectedInterview.result,
            feedback: selectedInterview.feedback
          }}
          onClose={handleStatusUpdate}
        />
      )}

      <Snackbar 
        open={alert.open} 
        autoHideDuration={6000} 
        onClose={() => setAlert(prev => ({ ...prev, open: false }))} 
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert 
          onClose={() => setAlert(prev => ({ ...prev, open: false }))} 
          severity={alert.severity}
          sx={{ width: '100%', boxShadow: 3 }}
        >
          {alert.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default StatusPage;